import sam6 from "../../assets/sam6.webp";
import { calculateAge } from "../../utils/calculateAge";
import styles from "./AboutHero.module.css";

const AboutHero = () => {
  const age = calculateAge("1997-06-12")

  return (
    <section className={styles.aboutHero}>
      <div className={styles.imageContainer}>
        <img
          src={sam6}  
          alt="About"
          className={styles.image}
        />
      </div>
      <div className={styles.textContainer}>
        <h1 className={styles.title}>
          I’m a {age}-year-old artist living in the Land of Enchantment.
        </h1>
        <p className={styles.text}>
          Samantha Olguin grew up immersed in musical theater, singing, and dancing from a young age. She was classically trained in piano from the ages 4-16 and passed Level 8 of the Royal School of Music piano exam with Distinction. Sam moved to Los Angeles at 18 years old to study Ethnomusicology at UCLA and pursue her passion for music and acting. She loves discovering new sounds informed by cultures and sounds from around the world. Sam released her first EP as she was graduating from UCLA. Her single, “Coffee”, has garnered over 50,000 total streams. While in Los Angeles, she did commercial modeling for companies including LensCrafters and DJI. In 2020, She moved to Albuquerque, NM, where she began exploring the growing TV & Film scene in the Land of Enchantment. Today, she continues her multifaceted artistic pursuits, engaging in art that bridges Chinese and American culture. Sam is signed with Bankston Talent Agency.
        </p>
      </div>
    </section>
  );
};

export default AboutHero;